import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.routerName,
    target: _ctx.externalTargetBlank ? '_blank' : 'self'
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1),
      _createElementVNode("i", {
        class: _normalizeClass([_ctx.icon, "ms-1 text-primary"])
      }, null, 2)
    ]),
    _: 1
  }, 8, ["to", "target"]))
}